import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import type {
  CreateProjectPeriodConfirmation,
  ProjectPeriodConfirmationStatus,
} from "@/types/projectPeriodConfirmation";

const service = new APIService<
  ProjectPeriodConfirmationStatus,
  CreateProjectPeriodConfirmation
>(API.ProjectPeriodConfirmations);

export const ProjectPeriodConfirmationService = {
  getStatus: (projectId: string, period: string) => {
    const params = new URLSearchParams({
      project_id: projectId,
      period,
    });
    return service.getStaticList<ProjectPeriodConfirmationStatus>(
      `/status?${params.toString()}`,
    );
  },
  create: (payload: CreateProjectPeriodConfirmation) => service.post(payload),
};
